import React from 'react';
import ReactImageZoom from 'react-image-zoom';

const ImageZoom = ({image}) => {

    return (
        <div className="item">
            {window.innerWidth > 1366
                ? <ReactImageZoom
                    img={image}
                    zoomPosition='original'/>
                : <figure className="zoom">
                    <img src={image} alt="" /></figure>
            }
        </div>
    );
};

export default ImageZoom;